<template>
    <div class="content">
        <iframe width="100%" height="100%" :src='myURL' style="border: 0;height: 100%;"></iframe>
    </div>
</template>
<script>
export default {
    data(){
        return{
            type:'',
            proId:'',
            sn:'',
            channel:'',
            myURL:''
        }
    },
    mounted(){
        var params = this.$route.params;
        this.proId = params.id;
        this.type = params.type;
        this.sn = params.sn;
        this.channel = params.channel;
        if(this.type=="1"){
            this.myURL = '/monitor/view/single.html?id='+this.proId+'&sn='+this.sn+'&channel='+this.channel;
        }else{
            this.myURL = '/daHua/sign.html?id='+this.proId+'&sn='+this.sn+'&channel='+this.channel;
        }
    },
    methods:{

    }
}
</script>
<style scoped>
    .content{
        height: 100vh;
        background: #fff;
    }
</style>